/* src/announcement/cards/AnnouncementCard/styles.js */

export default theme => {
  const { unit } = theme.spacing;
  const space = unit * 3;
  return {
    message: {
      marginTop: space,
    },
    formControl: {
      margin: space,
      marginBottom: 0,
    },
    messageContainer: {
      padding: space,
    },
    titleContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    group: {
      margin: `${unit}px 0`,
    },
    body: {
      padding: space,
    },
    input: {
      width: '40%',
    },
    deliveryForm: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-end',
      paddingBottom: space,
      flex: 1,
    },
    sendIcon: {
      marginLeft: unit,
    },
    alarmIcon: {
      marginRight: unit,
    },
    button: {
      marginLeft: 'auto',
    },
    buttonContainer: {
      padding: space,
      display: 'flex',
    },
  };
};



// WEBPACK FOOTER //
// ./src/modules/announcement/cards/AnnouncementCard/styles.js